import theme from "../../theme";

export const style = {
  SECTION: {
    backgroundColor: theme.backgroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",

    mobile: {
      desktop: {
        padding: 50,
      },
      smartphone: {
        padding: 30,
      },
    },
  },
  HEADLINE: {
    textAlign: "left",
    fontSize: "28pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    color: theme.foregroundColor,
  },
  TEXT: {
    textAlign: "left",
    fontFamily: theme.fontFamily,
    marginTop: 20,
    color: theme.foregroundColor,
    fontSize: "12pt",
    lineHeight: "18pt",
  },
  LIST: { marginTop: 40, paddingLeft: 0 },
  LI: {
    style: { marginTop: 60 },
    iconStyle: {
      color: theme.foregroundColor,
      backgroundColor: theme.backgroundColor,
      fontSize: "36pt",
      paddingRight: 15,
    },
  },
};
